import {
  Component, Directive, QueryList,
  Input
} from '@angular/core';

/**
 * Use textarea fields in forms to provide descriptions. Textarea fields are normally
 * found within a form but can also be part of a modal.
 */
@Component({
  selector: 'clo-input-textarea',
  templateUrl: './textarea-input.html',
  styleUrls: ['./input.scss']

})
export class CloInputTextarea {
  /*
   *  String value for the field ID
   */
  @Input() id: string;

  /*
   * String value for the label
   **/
  @Input() label: string;

  /*
    * String value for field name
  **/
  @Input() name: string;

  /*
   * Number value for the rows
   */
  @Input() rows = 10;

  /*
   * Number value for the cols
   */
  @Input() cols = 30;

  /**
    * Boolean value for whether the field is disabled
   */
 @Input() disabled: boolean;

  /**
   * String value for the placeholder text
   */
  @Input() placeholder: string;

  /**
   * String value for the error message
   */
  @Input() errorMessage: string;

  /**
   * Boolean value for whether the field is required
   *
   */
  @Input() required: boolean;

  /**
   * Boolean for whether the field is readOnly
   *
   */
  @Input() readOnly: boolean;

  /**
   * String for the value entered into the textarea
   *
   */
  @Input() value: string;
}
